// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aSummary-Bom2aSummary-module__main--kPFm_ {
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aSummary-Bom2aSummary-module__toolbar--yvjxP {
  padding: 4px 10px;
  display: flex;
  gap: 10px;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aSummary-Bom2aSummary-module__toolbarMain--yT3DB {
  flex: 1;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aSummary-Bom2aSummary-module__tableBox--r_iS4 {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aSummary-Bom2aSummary-module__rowsClickable--zHh9X .ant-table-row-level-0 {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom2a/Bom2aControl/Bom2aSummary/Bom2aSummary.module.less"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;EAEA,aAAA;EACA,sBAAA;AAAF;AAGA;EACE,iBAAA;EACA,aAAA;EACA,SAAA;AADF;AAIA;EACE,OAAA;AAFF;AAKA;EACE,OAAA;EACA,cAAA;AAHF;AAMA;EACE,eAAA;AAJF","sourcesContent":[".main {\n  flex: 1;\n  overflow: auto;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.toolbar {\n  padding: 4px 10px;\n  display: flex;\n  gap: 10px;\n}\n\n.toolbarMain {\n  flex: 1;\n}\n\n.tableBox {\n  flex: 1;\n  overflow: auto;\n}\n\n.rowsClickable :global(.ant-table-row-level-0) {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aSummary-Bom2aSummary-module__main--kPFm_`,
	"toolbar": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aSummary-Bom2aSummary-module__toolbar--yvjxP`,
	"toolbarMain": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aSummary-Bom2aSummary-module__toolbarMain--yT3DB`,
	"tableBox": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aSummary-Bom2aSummary-module__tableBox--r_iS4`,
	"rowsClickable": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aSummary-Bom2aSummary-module__rowsClickable--zHh9X`
};
export default ___CSS_LOADER_EXPORT___;
